import { Icon } from "./Icon";

export const ErrorDescription: React.FC = ({ children }) => (
  <div className="flex flex-col justify-around mb-3 p-4">
    <div className="flex flex-row items-center">
      <Icon name="exclamation-triangle" size="sm" color='gray' />
      <div className="ml-2 text-style-error">{children}</div>
    </div>
  </div>
);
